<template>
  <b-col cols="6" class="collar-leash-select-col">
    <b-img
      v-if="productStyle.image"
      :src="getImage(productStyle.image.original)"
      alt=""
      class="collar-leash-select-img"
      fluid-grow
      center
    />
    <div v-else-if="group.image">
      <b-img :src="getImage(group.image.original)" alt="" class="collar-leash-select-img d-only-block" fluid-grow center />
      <b-img
        :src="getImage(group.mobileImage.original || group.image.original)"
        alt=""
        class="collar-leash-select-img m-only-block"
        fluid-grow
        center
      />
    </div>
    <div class="d-flex flex-column justify-content-center mt-2 mt-md-3 mb-5">
      <h2 class="font-weight-bold text-secondary text-center">{{ group.name }} ${{ Number(group.price) }}</h2>
      <h3 class="text-muted-alt text-center">
        {{ $t('availableIn') }} {{ Number(group.productStyles.length) }}
        {{ $tc('Color', Number(group.productStyles.length)).toLowerCase() }}
      </h3>
      <section v-if="group.productStyles">
        <section>
          <div class="collar-leash-select-color-option-row mx-auto my-3">
            <div v-for="style in group.productStyles" :key="style.code" class="collar-leash-select-color-option-col">
              <b-link router-tag="div" href="javascript:void(0)" @click="selectedProductStyleCode = style.code" :title="`Explore ${style.name} product`">
                <b-img
                  v-if="style.image"
                  class="collar-leash-select-color-option-img"
                  :class="style.code === selectedProductStyleCode ? 'selected' : ''"
                  :src="getImage(style.image.thumbnail || style.image.original)"
                  alt=""
                  fluid
                />
              </b-link>
            </div>
          </div>
        </section>
      </section>
      <ValidationObserver :ref="`cl-group-form-${group.id}`" slim>
        <form @submit.prevent="onSubmit">
          <ValidationProvider v-slot="{ errors }" vid="collar-leash-color-select" :rules="{ required: false }" slim>
            <input v-model="selectedProductStyleCode" type="text" class="d-none" hidden />
            <span v-if="errors && errors[0]" class="text-danger"> {{ $t('selectA') }} {{ collar ? 'Collar' : 'Leash' }} {{ $t('Color') }}/{{ $t('style') }}</span>
          </ValidationProvider>
          <b-button
            variant="outline-primary"
            class="collar-leash-select-btn mt-3 w-100"
            type="submit"
            v-text="`Shop ${group.name ? group.name.split(' ')[0] || 'Now' : 'Now'}`"
          />
        </form>
      </ValidationObserver>
    </div>
  </b-col>
</template>

<script>
import getImage from '../../mixins/getImage';

export default {
  name: 'CollarLeashGroup',
  mixins: [getImage],
  props: {
    collar: {
      type: Boolean,
      required: false,
      default: true,
    },
    leash: {
      type: Boolean,
      required: false,
      default: false,
    },
    group: {
      type: Object,
      required: true,
    },
    productStyleCode: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      selectedProductStyleCode: this.group?.productStyles?.find((style) => style.code && style.code === this.productStyleCode)?.code || '',
    };
  },
  computed: {
    productStyle() {
      if (!this.selectedProductStyleCode) return {};
      return this.group?.productStyles?.find((style) => style?.code === this.selectedProductStyleCode);
    },
  },
  methods: {
    onSubmit() {
      this.$refs[`cl-group-form-${this.group?.id}`]?.validate().then(async (success) => {
        if (success)
          this.$emit('submit', {
            groupId: this.group?.id,
            productStyle: this.selectedProductStyleCode ? this.productStyle : this.group?.productStyles?.[0],
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.collar-leash-select-col {
  & .collar-leash-select-img {
    border-radius: 1rem;
    border: 1px solid $dp-gray-3;
    @media (max-width: 991px) {
      &.d-only-block {
        display: none !important;
      }
      &.m-only-block {
        display: block !important;
      }
    }
    @media (min-width: 991px) {
      &.d-only-block {
        display: block !important;
      }
      &.m-only-block {
        display: none !important;
      }
    }
  }
  & .collar-leash-select-color-option-row {
    display: grid;
    grid-gap: 0.75rem 1rem;
    justify-content: center;
    grid-template-columns: repeat(auto-fit, 45px);
    grid-auto-rows: minmax(45px, auto);
    .collar-leash-select-color-option-col {
      flex: 0 0 18.5%;
      max-width: 18.5%;
      & .collar-leash-select-color-option-img {
        border-radius: 8px;
        border: 1px solid $dp-gray-3;
        max-width: 45px;
        min-height: 45px;
        &:hover,
        &.selected {
          border-color: $dp-navy;
          outline: $dp-navy solid 1px;
        }
      }
    }
  }
}
</style>
